import { render, staticRenderFns } from "./InvestorPmResumeData.vue?vue&type=template&id=0a38a23e&scoped=true&"
import script from "./InvestorPmResumeData.vue?vue&type=script&lang=js&"
export * from "./InvestorPmResumeData.vue?vue&type=script&lang=js&"
import style0 from "./InvestorPmResumeData.vue?vue&type=style&index=0&id=0a38a23e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38a23e",
  null
  
)

export default component.exports